import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/Home'
import About from '../views/about/About'
import Projects from '../views/projects/Projects'
import Contact from '../views/contact/Contact'
import Services from '../views/services/Services'
import Privacy from '@/views/privacy/Privacy.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/services',
    name: 'Services',
    component: Services
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/projects',
    name: 'Projects',
    component: Projects
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/privacy',
    name: 'Privacy Policy',
    component: Privacy
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
